import { Visibility, VisibilityOff } from '@mui/icons-material'
import { Box, Button, DialogActions, DialogContent, FormControl, FormLabel, IconButton, InputAdornment, TextField } from '@mui/material'
import apiManagerUser from 'api/manager-users'
import PopoverPwdTextfield from 'components/Popover/PopoverPwdTextfield'
import { useFormik } from 'formik'
import { useMenuCC } from 'hooks'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { endSession as logout } from 'store/sessionSlice'
import { color } from 'theme'
import { setCloseDialogCC, toastError, toastSuccess } from 'utils/helpers'
import { validateNewPwd } from 'utils/validates'
import * as yup from 'yup'
import DialogBaseCC from './DialogBaseCC'
import { DIALOG_ID } from './constant'
import { PATH_ROOT } from 'constants/api'

const validationSchema = yup.object({
    currentPwd: yup
        .string()
        .required('dialog.changepwd.requiredCurrent'),
    newPwd: yup
        .string()
        .required('dialog.changepwd.requiredNew')
        .test('valid-newpwd',  ('validate.wrongPwd'), (value, context) => validateNewPwd({ newPwd: value, currentPwd: context.parent.currentPwd }).length === 0),
    renewPwd: yup
        .string()
        .oneOf([yup.ref('newPwd'), null], 'dialog.changepwd.notMatch')
        .required('dialog.changepwd.requiredReNew')
});

const DialogChangePwdCC = () => {
    const { t } = useTranslation()
    const { open, anchorEl, setAnchorEl } = useMenuCC()
    const [errors, setErrors] = useState([])
    const labelRef = useRef(null)
    const [initialValues, setInitialValues] = useState({
        currentPwd: '',
        newPwd: '',
        renewPwd: ''
    })
    const [showCurrentPwd, setShowCurrentPwd] = useState(false);
    const [showNewPwd, setShowNewPwd] = useState(false);
    const [showRenewPwd, setShowRenewPwd] = useState(false);

    const dispatch = useDispatch()

    const logoutApi = () => {
        return apiManagerUser.logout(); 
    };

    const handleOpenPopover = (e) => {
        const _errors = validateNewPwd(formik.values)
        setErrors(_errors)
        setAnchorEl(e.currentTarget)
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
        apiManagerUser
            .updatePasswordByToken({ newPassword: values.newPwd, oldPassword: values.currentPwd })
            .then((res) => {
                if (res.status === 200) {
                    toast.dismiss()
                    setCloseDialogCC()
                    toastSuccess(t('toast.subChangePwdSuccess'))
                    // toastSuccess(<ToastCard title={t('toast.changePwdSuccess')} content={t('toast.subChangePwdSuccess')} type='success' />, TOAST_POSITION.topCenter);
                    setTimeout(() => {
                        logoutApi().then((r) => {
                            dispatch(logout());
                            localStorage.setItem("checkEventPopupByUser", 0);
                        }).finally(() => {
                            dispatch(logout());
                            window.location.href = `${PATH_ROOT}/auth/login`
                            localStorage.setItem("checkEventPopupByUser", 0);
                        });
                    }, 5000);
                }
            })
            .catch((error) => {
                if (error.response.data.detail === 'ER_POLICY_PASSWORD') {
                    toastError(
                        t('validate.pwdRule', {
                            pwdMinLength: error.response.data.policy.password_min_length,
                            pwdMaxLength: error.response.data.policy.password_max_length,
                            policyNumber: error.response.data.policy.password_number,
                            policySpecial: error.response.data.policy.password_special,
                            policyUppercase: error.response.data.policy.password_uppercase,
                        }),
                    );
                } else if (error.response.data.detail === 'Password not valid') {
                    toastError(t('validate.wrongOldPassword'))
                }
                else if (error.response.data.detail.detail === 'Pwd over times change') {
                    const time = moment.unix(error.response.data.detail.time).format('YYYY-MM-DD HH:mm:ss')
                    const timeSuccess = moment(time).add(24, 'hours')
                    let totalSeconds = moment(timeSuccess).diff(moment(), 'seconds')
                    let hours = Math.floor(totalSeconds / 3600);
                    totalSeconds %= 3600;
                    let minutes = Math.floor(totalSeconds / 60);
                    let seconds = totalSeconds % 60;
                    const timeChangePwd = `${t('toast.subChangePwd')} ${hours ? t('toast.subHours', {hour: hours}) : ''}${minutes ? t('toast.subMinutes', {minute: minutes}) : ''}${seconds ? t('toast.subSeconds', {second: seconds}) : ''}` 

                    // toastError(<ToastCard content={timeChangePwd} title={t('toast.overChangePwd')} type='err' />, TOAST_POSITION.topCenter)
                    toastError(t('toast.overChangePwd'), timeChangePwd)
                }
                else toastError(t('toast.changePwdError'));
            });
        },
    });

    useEffect(() => {
        const _errors = validateNewPwd(formik.values)
        setErrors(_errors)
        return () => {
            setInitialValues({
                currentPwd: '',
                newPwd: '',
                renewPwd: ''
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.newPwd])

    return (
        <DialogBaseCC id={DIALOG_ID.CHANGE_PWD} title={t('dialog.changepwd.title')}>
            <Box>
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent>
                        <FormControl fullWidth>
                            <FormLabel>{t('dialog.changepwd.lableCurrentPwd')}<span style={{ color: color.main }}>*</span></FormLabel>
                            <TextField
                                autoFocus={true}
                                fullWidth
                                id="currentPwd"
                                name="currentPwd"
                                type={showCurrentPwd ? 'password' : 'text'}
                                value={formik.values.currentPwd}
                                onChange={e => formik.setFieldValue('currentPwd', e.target.value)}
                                error={formik.touched.currentPwd && Boolean(formik.errors.currentPwd)}
                                helperText={formik.touched.currentPwd && t(formik.errors.currentPwd)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" style={{paddingRight: '8px'}}>
                                        {formik.values.currentPwd !== '' ? (
                                            <IconButton
                                                
                                                tabIndex={-1}
                                                aria-label="toggle password visibility"
                                                onClick={() => {formik.setFieldValue('currentPwd', '')}}
                                            >
                                                <i className="fas fa-times clear-input"></i>
                                            </IconButton>
                                        ) : (
                                            <></>
                                        )}
                                        <IconButton
                                            tabIndex={-1}
                                            aria-label="toggle password visibility"
                                            onClick={() => {setShowCurrentPwd(!showCurrentPwd)}}
                                        >
                                            {!showCurrentPwd ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                    ),
                                }}
                            />
                        </FormControl>
                        <FormControl fullWidth sx={{ marginY: '20px' }}>
                            <FormLabel ref={labelRef}>{t('dialog.changepwd.lableNewPwd')}<span style={{ color: color.main }}>*</span></FormLabel>
                            <TextField
                                fullWidth
                                id="newPwd"
                                name="newPwd"
                                type={showNewPwd ? 'password' : 'text'}
                                value={formik.values.newPwd}
                                error={Boolean(formik.errors.newPwd)}
                                helperText={Boolean(formik.errors.newPwd) && t(formik.errors.newPwd)}
                                onChange={e => formik.setFieldValue('newPwd', e.target.value)}
                                onBlur={(e) => {
                                    setAnchorEl(null)
                                }}
                                onClick={handleOpenPopover}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" style={{paddingRight: '8px'}}>
                                        {formik.values.newPwd !== '' ? (
                                            <IconButton
                                                
                                                tabIndex={-1}
                                                aria-label="toggle password visibility"
                                                onClick={() => {formik.setFieldValue('newPwd', '')}}
                                            >
                                                <i className="fas fa-times clear-input"></i>
                                            </IconButton>
                                        ) : (
                                            <></>
                                        )}
                                        <IconButton
                                            tabIndex={-1}
                                            aria-label="toggle password visibility"
                                            onClick={() => {setShowNewPwd(!showNewPwd)}}
                                        >
                                            {!showNewPwd ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                    ),
                                }}
                            />
                            <PopoverPwdTextfield open={open} anchorEl={anchorEl} setAnchorEl={setAnchorEl} errors={errors} value={formik.values.newPwd} />
                        </FormControl>
                        <FormControl fullWidth>
                            <FormLabel>{t('dialog.changepwd.lableReNewPwd')}<span style={{ color: color.main }}>*</span></FormLabel>
                            <TextField
                                fullWidth
                                id="renewPwd"
                                name="renewPwd"
                                type={showRenewPwd ? 'password' : 'text'}
                                value={formik.values.renewPwd}
                                onChange={e => formik.setFieldValue('renewPwd', e.target.value)}
                                error={formik.touched.renewPwd && Boolean(formik.errors.renewPwd)}
                                helperText={formik.touched.renewPwd && t(formik.errors.renewPwd)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" style={{paddingRight: '8px'}}>
                                        {formik.values.renewPwd !== '' ? (
                                            <IconButton
                                                
                                                tabIndex={-1}
                                                aria-label="toggle password visibility"
                                                onClick={() => {formik.setFieldValue('renewPwd', '')}}
                                            >
                                                <i className="fas fa-times clear-input"></i>
                                            </IconButton>
                                        ) : (
                                            <></>
                                        )}
                                        <IconButton
                                            tabIndex={-1}
                                            aria-label="toggle password visibility"
                                            onClick={() => {setShowRenewPwd(!showRenewPwd)}}
                                        >
                                            {!showRenewPwd ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                    ),
                                }}
                            />
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button variant='outlined' onClick={setCloseDialogCC}>{t('dialog.cancel')}</Button>
                        <Button type='submit' disabled={Boolean(formik.errors.currentPwd) || Boolean(formik.errors.newPwd) || Boolean(formik.errors.renewPwd)}>{t('dialog.change')}</Button>
                    </DialogActions>
                </form>
            </Box>
        </DialogBaseCC>
    )
}

export default DialogChangePwdCC
